import { MenuStates } from '@frontend-site/main-header/domain';
import { PanayaRoute } from '@frontend-site/shared/router-store';
import { LoopbackComponent } from '@frontend-site/shared/hybrid';

export const REPORTS_ROUTES: PanayaRoute = Object.freeze<PanayaRoute>({
    path: 'reports/:companyId',
    data: { navState: 'reports' },
    children: [
        {
            path: 'releaseReports/:id',
            data: { navState: 'reports.releaseReports', menuState: MenuStates.RELEASE },
            children: [
                {
                    path: 'developmentProgress',
                    data: { navState: 'reports.releaseReports.developmentProgress', rememberMe: true },
                    component: LoopbackComponent
                },
                {
                    path: 'requirementCoverage',
                    data: { navState: 'reports.releaseReports.requirementCoverage' },
                    component: LoopbackComponent
                },
                {
                    path: 'defectsStatus',
                    data: { navState: 'reports.releaseReports.defectsStatus' },
                    component: LoopbackComponent
                },
                {
                    path: 'workflowsApprovalStatus',
                    data: { navState: 'reports.releaseReports.workflowsApprovalStatus' },
                    component: LoopbackComponent
                },
                {
                    path: 'overlappingRequirements',
                    data: { navState: 'reports.releaseReports.overlappingRequirements' },
                    component: LoopbackComponent
                },
                {
                    path: 'changeRequests',
                    data: { navState: 'reports.releaseReports.changeRequests' },
                    component: LoopbackComponent
                }
            ]
        }
    ]
});
